import { useEffect, useState } from "react";
import { Map, useMap, useMapsLibrary } from "@vis.gl/react-google-maps";

const DARK_STYLE = [
  { elementType: "geometry", stylers: [{ color: "#1a1a1a" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#0a0a0a" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#9CA3AF" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#2a2a2a" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#0d1b2a" }] },
  { featureType: "poi", stylers: [{ visibility: "off" }] },
];

function Directions({ origin, destination }) {
  const map = useMap();
  const routesLib = useMapsLibrary("routes");
  const [renderer, setRenderer] = useState(null);

  useEffect(() => {
    if (!routesLib || !map) return;
    const r = new routesLib.DirectionsRenderer({
      map, suppressMarkers: false,
      polylineOptions: { strokeColor: "#D4AF37", strokeWeight: 4, strokeOpacity: 0.9 },
    });
    setRenderer(r);
    return () => r.setMap(null);
  }, [routesLib, map]);

  useEffect(() => {
    if (!renderer || !routesLib) return;
    const svc = new routesLib.DirectionsService();
    svc.route({ origin, destination, travelMode: window.google.maps.TravelMode.DRIVING })
      .then((res) => renderer.setDirections(res))
      .catch(() => {});
  }, [renderer, routesLib, origin, destination]);

  return null;
}

export default function RouteMap({ origin, destination }) {
  if (!origin || !destination) return null;
  return (
    <div className="w-full h-72 border border-white/10 overflow-hidden" data-testid="route-map">
      <Map defaultCenter={origin} defaultZoom={10} gestureHandling="greedy"
        disableDefaultUI={true} zoomControl={true} styles={DARK_STYLE} className="w-full h-full">
        <Directions origin={origin} destination={destination} />
      </Map>
    </div>
  );
}
